module.exports = __webpack_public_path__ + "static/media/XL.e26a03d0.jpg";